export const BASE_ACTION_CONSTANT = 'app/CheckoutJourney';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;
export const SET_CHOICE = `${BASE_ACTION_CONSTANT}/SET_CHOICE`;
export const SET_PLATFORM = `${BASE_ACTION_CONSTANT}/SET_PLATFORM`;
export const SET_PLATFORM_OPTIONS = `${BASE_ACTION_CONSTANT}/SET_PLATFORM_OPTIONS`;
export const GET_INTEGRATION_STATUS = `${BASE_ACTION_CONSTANT}/GET_INTEGRATION_STATUS`;
export const GET_INTEGRATION_STATUS_SUCCESS = `${BASE_ACTION_CONSTANT}/GET_INTEGRATION_STATUS_SUCCESS`;
export const GET_INTEGRATION_STATUS_FAILURE = `${BASE_ACTION_CONSTANT}/GET_INTEGRATION_STATUS_FAILURE`;
export const UPDATE_INTEGRATION_STATUS: any = `${BASE_ACTION_CONSTANT}/UPDATE_INTEGRATION_STATUS`;
export const UPDATE_INTEGRATION_STATUS_SUCCESS: string = `${BASE_ACTION_CONSTANT}/UPDATE_INTEGRATION_STATUS_SUCCESS`;

export const DAY_ZERO_CHECKOUT = {
  JOURNEY_STARTED: 'DAY_ZERO_CHECKOUT_JOURNEY_STARTED',
  PLUGIN_JOURNEY_STARTED: 'DAY_ZERO_PLUGIN_JOURNEY_STARTED',
  SOCIAL_SHARE_JOURNEY_STARTED: 'DAY_ZERO_SOCIAL_SHARE_JOURNEY_STARTED',
  SDK_JOURNEY_STARTED: 'DAY_ZERO_SDK_JOURNEY_STARTED',
  JOURNEY_COMPLETED: 'DAY_ZERO_CHECKOUT_JOURNEY_COMPLETED',
};

export const GuideURL =
  'https://www.cashfree.com/docs/payments/online/webhooks/configure';

export const HerGuideURL =
  'https://www.cashfree.com/docs/payments/online/webhooks/overview';

export const API_REF_DOC_URL =
  'https://www.cashfree.com/docs/api-reference/payments/latest/overview#payment-gateway-end-points';
